import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN_WEB_MEDPORTAL,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: window.location.hostname.includes('staging.healthhelper') ? 'staging' : 'production',
  tracesSampleRate: 1.0,
  enabled: process.env.NODE_ENV !== 'development',
  tracePropagationTargets: ['patient.staging.healthhelper.ai', 'patient.healthhelper.ai'],
  attachStacktrace: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
